// src/AppRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AppLayout from "./components/layout/AppLayout";
import RequireAuth from "./components/auth/RequireAuth";
import "./index.css";

// ---- Backoffice (เดิม) ----
import PricingQueuePage from "./screens/dashboard/PricingQueuePage";
import AccessoryHistoryPage from "./screens/dashboard/AccessoryHistoryPage";
import PricingQueueDetail from "./screens/dashboard/PricingQueuePageDetail";

import ProductsMainPage from "./screens/products/Main";
import Accessory from "./screens/products/Accessories";
import StockPage from "./screens/products/StockPage";
import StockBuyInPage from "./screens/products/StockBuyInPage";
import SellOutPage from "./screens/products/StockBuyOutPage";

import RepairListPage from "./screens/repairs/Repairs";
import RepairCreatePage from "./screens/repairs/RepairCreatePage";

import PawnListPage from "./screens/pawn/Pawn";
import PawnCreatePage from "./screens/pawn/PawnCreatePage";

import MainCategoriesPage from "./screens/settings/master/MainCategoriesPage";
import AccessoryCategoriesPage from "./screens/settings/master/AccessoryCategoriesPage";
import ModelsPage from "./screens/settings/master/ModelsPage";
import CapacitiesPage from "./screens/settings/master/CapacitiesPage";
import ColorsPage from "./screens/settings/master/ColorsPage";
import ProfilePage from "./screens/settings/ProfilePage";

// ---- Public (ใหม่) ----
import PublicLayout from "./screens/public/PublicLayout";
import DashboardPage from "./screens/public/DashboardPage";
import AllProductsPage from "./screens/public/AllProductsPage";
import ProductDetailPage from "./screens/public/ProductDetailPage";
import Login from "./screens/login";
import CategoryModelsPage from "./screens/settings/master/CategoryModelsPage";
import EquipmentPage from "./screens/settings/master/EquipmentPage";
import QualityPage from "./screens/settings/master/QualityPage";
import WarrantyPage from "./screens/settings/master/WarrantyPage";
import ContactPage from "./screens/settings/master/Contact";
import AccessoryModelsPage from "./screens/settings/master/AccessoryModelsPage";

export default function AppRoutes() {
  return (
    <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="login" element={<Login />} />
          <Route path="products" element={<AllProductsPage />} />
          <Route path="products/:id" element={<ProductDetailPage />} />
        </Route>

        {/* BACKOFFICE */}
        <Route element={<RequireAuth redirectTo="/login" />}>
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Navigate to="main" replace />} />

            <Route path="pricing-queue" element={<PricingQueuePage />} />
            <Route path="pricing-queue/:imei" element={<PricingQueueDetail />} />
            <Route path="accessory-history" element={<AccessoryHistoryPage />} />

            <Route path="products" element={<Navigate to="products/main" replace />} />
            <Route path="main" element={<ProductsMainPage />} />
            <Route path="products/main" element={<ProductsMainPage />} />
            <Route path="products/accessories" element={<Accessory />} />
            <Route path="products/stock" element={<StockPage />} />
            <Route path="products/stock-buy-in" element={<StockBuyInPage />} />
            <Route path="products/stock-buy-in/:id" element={<StockBuyInPage />} />
            <Route path="products/stock-sell-out" element={<SellOutPage />} />

            <Route path="repairs" element={<RepairListPage />} />
            <Route path="repair" element={<RepairListPage />} />
            <Route path="repair/create" element={<RepairCreatePage />} />
            <Route path="repair/:id" element={<RepairCreatePage />} />

            <Route path="pawn" element={<PawnListPage />} />
            <Route path="pawn/create" element={<PawnCreatePage />} />
            <Route path="pawn/create/:id" element={<PawnCreatePage />} />

            <Route path="settings" element={<Navigate to="settings/master/main-categories" replace />} />
            <Route path="settings/master/main-categories" element={<MainCategoriesPage />} />
            <Route path="settings/master/accessory-categories" element={<AccessoryCategoriesPage />} />
            <Route path="settings/master/models" element={<ModelsPage />} />
            <Route path="settings/master/capacities" element={<CapacitiesPage />} />
            <Route path="settings/master/equipment" element={<EquipmentPage />} />
            <Route path="settings/master/colors" element={<ColorsPage />} />
            <Route path="settings/master/quality" element={<QualityPage />} />
            <Route path="settings/master/warranty" element={<WarrantyPage />} />
            <Route path="settings/master/contact-infos" element={<ContactPage />} />
            <Route path="settings/profile" element={<ProfilePage />} />
            <Route path="settings/master/categories/:categoryId/models" element={<CategoryModelsPage />} />
            <Route path="settings/master/accessories/:categoryId/models" element={<AccessoryModelsPage />} />
          </Route>
        </Route>

        {/* fallback (นอกสุด) */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  );
}
